import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserManagementService } from 'app/modules/user-management/services/user-management.service';
import module from 'app/modules/user-management/user-management.module'

@Component({
  selector: 'app-edit-roles-modal',
  templateUrl: './edit-roles-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-roles-modal.component.scss']
})
export class EditRolesModalComponent {
  public rolePermissionBody = {
    roleId: '',
    permissions: []
  }
  public permissions : string[] = ['']
  public selectedPermission: string[] = ['']

  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditRolesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public rolesData: any,
    public dialog: MatDialog,
    private userManagementService: UserManagementService ) {}

    ngOnInit(): void {
      this.getPermissionsList()
      this.selectedPermission = this.rolesData.permissions
    }

    getPermissionsList(){
      this.userManagementService.permissions$.subscribe((res)=>{
        this.permissions = res.data.data.map(res => res.name)
      })
    }

    updateRole(){
      this.rolePermissionBody.roleId = this.rolesData.id
      this.rolePermissionBody.permissions = this.selectedPermission

      this.userManagementService.assignOrUpdatePermissionToRole(this.rolePermissionBody).subscribe(
        (res)=> {
        if(res.isSuccess){
          this.closeDialog(res.isSuccess)
        }
        }
      )
    }

    isPermissionChange(): boolean {
      // Check if selected permissions are equal to stored permissions or if loading
      return this.selectedPermission.length === 0 || 
             JSON.stringify(this.selectedPermission.sort()) === JSON.stringify(this.rolesData.permissions.sort()) || 
             this.isLoading;
    }

    closeDialog(isSuccess): void {
      this.dialogRef.close(isSuccess);
    }
}
